/* ============================================
   LIBAYAH - MR PARKER THEME HEADER JS
   Hide logo when mobile menu opens
   ============================================ */

document.addEventListener('DOMContentLoaded', function() {
  
  // Get elements
  const menuOpenBtn = document.querySelector('.slideout__trigger-mobile-menu.js-slideout-open');
  const menuCloseBtn = document.querySelector('.slideout__trigger-mobile-menu.js-slideout-close');
  const mobileLogo = document.querySelector('.header__mobile__logo-wrapper');
  const body = document.body;
  
  // Function to hide logo
  function hideLogo() {
    if (mobileLogo) {
      mobileLogo.classList.add('is-hidden');
      body.classList.add('slideout-open');
    }
  }
  
  // Function to show logo
  function showLogo() {
    if (mobileLogo) {
      mobileLogo.classList.remove('is-hidden');
      body.classList.remove('slideout-open');
    }
  }
  
  // Listen for menu open
  if (menuOpenBtn) {
    menuOpenBtn.addEventListener('click', function() {
      // Small delay to sync with animation
      setTimeout(hideLogo, 50);
    });
  }
  
  // Listen for menu close
  if (menuCloseBtn) {
    menuCloseBtn.addEventListener('click', function() {
      showLogo();
    });
  }
  
  // Also listen for popover toggle events (Mr Parker uses popovers)
  const slideoutNav = document.querySelector('#slideout-mobile-navigation, [id*="slideout-mobile"]');
  
  if (slideoutNav) {
    // When popover shows
    slideoutNav.addEventListener('toggle', function(e) {
      if (e.newState === 'open') {
        hideLogo();
      } else {
        showLogo();
      }
    });
    
    // Fallback: MutationObserver to watch for popover state changes
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'popover' || mutation.attributeName === 'class') {
          const isOpen = slideoutNav.matches(':popover-open') || 
                         slideoutNav.classList.contains('is-open') ||
                         slideoutNav.classList.contains('active');
          if (isOpen) {
            hideLogo();
          } else {
            showLogo();
          }
        }
      });
    });
    
    observer.observe(slideoutNav, { attributes: true });
  }
  
  // Listen for clicks on overlay to close menu
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('slideout__overlay') || 
        e.target.classList.contains('js-slideout-close')) {
      showLogo();
    }
  });
  
  // Listen for escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      showLogo();
    }
  });
  
  /* ============================================
     ADD DROPDOWN INDICATORS TO NAV ITEMS
     ============================================ */
  
  // Desktop: Add class to nav items that have submenus
  const desktopNavItems = document.querySelectorAll('.header__nav > ul > li');
  
  desktopNavItems.forEach(function(item) {
    const hasSubmenu = item.querySelector('ul, .header__submenu, .mega-menu');
    if (hasSubmenu) {
      item.classList.add('has-dropdown');
    }
  });
  
  /* ============================================
     ENSURE CONSISTENT PADDING ON ACCORDION
     ============================================ */
  
  // Make sure all accordion items have consistent height
  const accordionHeaders = document.querySelectorAll('.c-accordion__header');
  
  accordionHeaders.forEach(function(header) {
    const link = header.querySelector('.c-accordion__link');
    const arrow = header.querySelector('.dropdown-arrow');
    
    if (link && arrow) {
      // Ensure they're aligned properly
      header.style.display = 'flex';
      header.style.alignItems = 'stretch';
    }
  });
  
});

/* ============================================
   ALTERNATIVE: Using Theme's Built-in Events
   ============================================ */

// If the theme dispatches custom events, listen for them
window.addEventListener('slideout:open', function() {
  const mobileLogo = document.querySelector('.header__mobile__logo-wrapper');
  if (mobileLogo) {
    mobileLogo.classList.add('is-hidden');
  }
});

window.addEventListener('slideout:close', function() {
  const mobileLogo = document.querySelector('.header__mobile__logo-wrapper');
  if (mobileLogo) {
    mobileLogo.classList.remove('is-hidden');
  }
});